import { Auth } from 'aws-amplify';
import sha256 from 'crypto-js/sha256';

async function determineUserRole() {
    const superUserHashes = [
        '84fd0bb91c5a47ddada63528fc6c6d7de67c6eac79fe24593d63027f0efad705', // victorr@gmail.com
        '175e52499162af1bb112e7e2a6f5e419c7e0d5fde4879ff5476b47bf4bee70ff', // rene
        '34148c46394137c7a1f13766ef1a7af7e1b6c6ea5941266ad5b3e4f9f7cb3767', // rwiebe@monitordetemperaturas.com

        'ec4532d08a8306541d6f12143fb0cf79e88747d1339ae944c3b678fd3c4a529e', // slickhanoi@yahoo.com
    ];

    const adminHashes = [
        '7d867d2da86a2d8839265176096e0a203b866b32a1306dbaec7b2086b8a3f73c', // victorr+prueba@gmail.com

        '20fd098178a1b11b93e6db454d477f4b9f759fb192e0777e4a3f2957045e5d51', // monitordetemperaturas@gmail.com
        '8177229a38fd153bd6ecb501e9ce660ad0af55c640878325e4450c3fdb75e9c7', // rterrazas@liderlac.mx
        'd326f3246ba90bf70a1e73e218a08170952cf313ad522f358254a2c102bb8d90', // jmhernandez@liderlac.mx
        // 'd1939aa93b4818ecd25ff0a392d28e1bf765958f840d2196431e917b31ee769a', // jjasso@liderlac.mx
        '0158952fbbddd9029dd2b55bd4d0338b6468b14410454aa7063124249ccd9031', // alonso.lopez@liderlac.mx
        //'fb6f470575d0cc22e7edcb2256643bf404f9a6da5e5e4e40abeb1ece3942266a', // jguerrero@lechezaragoza.com
        '7bd4b95c533e1a5af6b294caa5592ada18680328a92f2acdec38c53124667cac', // geraibarra2009@hotmail.com
        'bc27d10c3a5db2d5c48c98e3c56adfefa1e12494033d08ad88eeaa237406acd0', // sblaine@lechezaragoza.com
        '5ec37ef6937c9ffea00c28b74c22156784446ab6c63026c450ac38c2477c4ae1', // ibatista@lederlac.mx
        'd2f2a1950b406379771c738974d57100e12021b79ad15be26cef8eda1d213d70', // jagomez@lechezaragoza.com
        '306a97a8be5ff13da2ec4f55d445f40b3c2385f48efd70e3711e6ccee83f2f8c', // jmquinonez@lechezaragoza.com
        '9a889aaeb5510c5f72dc4d35d4ec2a570cf5fb1c380034717b1722354cba442a', // ajimenez@liderlac.mx 

        // Estos fueron super usuarios temporales - necesitaban accesso a salidas y llegadas
        '37d79c139d9740986f83b4504c131e28754dcb1c0abcec1b51af9889221023a3', // mchavez@liderlac.mx
        '8fd1f416867f3f7f9fe910014db91ecab4cbce87c65e50252d78c1161aeddff3', // mayusa2778@gmail.com
        '7d784903fe6a7389a8c7edfe473b38379aca549bbadf53e8b0d30f9259fbc025', // carcivar@liderlac.mx

        'ec4532d08a8306541d6f12143fb0cf79e88747d1339ae944c3b678fd3c4a529e', // slickhanoi@yahoo.com
    ];

    const checkoutHashes = [
        // '7d867d2da86a2d8839265176096e0a203b866b32a1306dbaec7b2086b8a3f73c', // victorr+prueba@gmail.com
        '20fd098178a1b11b93e6db454d477f4b9f759fb192e0777e4a3f2957045e5d51', // monitordetemperaturas@gmail.com
        '3cc7a4287f4be9e1fb120676030eaaaa43b3f5e6c00f93766734037867e82a9f', // chihuahuacantera@gmail.com
        '0d6eec0c8a3577a535af83c914960b609f1ec7b5c2f9a5e2ef6dccb87e445bed', // chihuahuaplanta@gmail.com
        '3196bfbead482dd05ce0c9330f0fbd33cc78c2c81bdd7580c33aa48d8e59d898', // juarezcedis@gmail.com
        '89a3841abada69eb3f3c21ea7a36248ec559d8a3ac7d834fba53ee051c15b6ec', // cuauhcedis@gmail.com
        '7eb761cae9991b2bf890b83f354f8d0247e3509776b835b0d0e169e31866a587', // aguaprietacedis@gmail.com
        '1ea8456ff7f556c98369e316b23e4b581d573bc215be7686d8b8dffbca2bad99', // camargocedis@gmail.com
        '83581a562da2a6ac61047d58e148dc0ac0c1208e604df415608e393b54654d33', // deliciascedis@gmail.com
        '8eec2f329c8de4616d1ab14b345faf0510cc603ba6955a4e89375bda013e3e6c', // parralcedis@gmail.com
        'cb33ef81e089056f3cc1bc4fceda506c028ad22fb8a65b1feb2911ba4fb5e739', // sotomaynezcedis@gmail.com
        'dd6cea1f47d8e82210013b2470b32ffb9398b2d176edbc432c603850d75abcdf', // casasgcedis@gmail.com
        '724c0bc4f6bfcb0fde0632347d2e146cb1e29f4f0a572c0da9aaad29d1ae9c9b', // sanjosecedis@gmail.com
        '41cb14a3daadcdb7f1b0f4ee0281eadb57c1e9fd05a012217de10d6746900bc1', // bquintanacedis@gmail.com
        '2566f02c071e2447bcd50a62170bb540e1b0671e33c898a8a50f952463a5b9a0', // balvaneracedis@gmail.com
        '4c016c5591040dda2f08555a8bde314cfd25d5bd5ff9f14eff12e93a7aaded30', // queretaroplantacedis@gmail.com
        '3467e725409e20939d42dfc3c65999b77c317284f99be1d8b15393f9dcc3d6aa', // sanjuandelriocedis@gmail.com
        'd3eea103cb82db95091df9b5841ef0ae0639e53193d612799e0209aae55996db', // centronorteqro@gmail.com

    ];

    // xxx();

    try {
        const user = await Auth.currentAuthenticatedUser();
        const hash = sha256( user.attributes.email ).toString();

        const isSuperUser    = superUserHashes.includes( hash ),
              isAdminUser    = adminHashes.includes( hash ),
              isCheckoutUser = checkoutHashes.includes( hash );

        // console.log( `User email ${user.attributes.email}, hashed ${hash}, result = ${result}` );

        return { isSuperUser, isAdminUser, isCheckoutUser };
    }
    catch ( error ) {
        return false;
    }
}

export { determineUserRole };
